import { useIntl } from "react-intl"

import { AssignedConversation } from "@doktor-se/bones-ui/dist/web-shared/types"

import { ReassignRequestConversation } from "reducers/conversations/conversations.reducer"

import MyBookingsList from "./MyBookingsList"
import MyErrandsList from "./MyErrandsList"
import MyRequestsList from "./MyRequestsLists"

import styles from "./AssignedConversationList.module.scss"

interface AssignedConversationListProps {
  requests: ReassignRequestConversation[]
  active: AssignedConversation[]
  booked: AssignedConversation[]
}

const AssignedConversationList = ({ requests, active, booked }: AssignedConversationListProps) => {
  const intl = useIntl()
  return (
    <>
      <div className={styles.listContainer}>
        <MyRequestsList conversations={requests} />
      </div>
      <div className={styles.divider}></div>
      <div className={styles.listContainer}>
        <MyErrandsList title={intl.formatMessage({ id: "label.overview.my_errands" })} conversations={active} />
      </div>
      <div className={styles.divider}></div>
      <div className={styles.listContainer}>
        <MyBookingsList title={intl.formatMessage({ id: "label.overview.my_bookings" })} conversations={booked} />
      </div>
    </>
  )
}

export default AssignedConversationList
